var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExampleStory',[_c('TfTable',_vm._b({on:{"pageSelected":function($event){return _vm.$router.push({
      query: {
        ..._vm.$route.query,
        pageSelected: $event,
      }
    })},"changeSortCriteria":function($event){return _vm.$router.push({
      query: {
        ..._vm.$route.query,
        sortDirection: $event.sortDirection,
        sortProp: $event.sortProp
      }
    })}}},'TfTable',{
      parentalControls: true,
      pageLimit: 25,
      pageSelected: Number(_vm.$route.query.pageSelected) || 1,
      pagination: true,
      tableData: [..._vm.table.data],
      tableMeta: _vm.tableMeta,
    },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }